import { Observable } from "rxjs";

export interface Flusso {
  name: string;
  settings: any;
  fields?: any;
  privacies?: any;
  notAllowed?: any;
  css?: string;
  uid: string;
  id?: string;
  slug?: string;
  timestamp?: number;
}

export abstract class FlussoData {
  abstract createFlusso(form: Flusso);
  abstract getFlussi(pagination, filter, order);
  abstract getFlusso(id: string);
  abstract editFlusso(data: Flusso, id: string);
  abstract deleteFlusso(id: string);
  abstract duplicateFlusso(id: string);
}
